/** 登录方式 */
export enum SYSTEM_LOGIN_TYPE {
    /** 账号登陆 */
    ADMIN = 1,
    /** 手机登录 */
    CUSTOMER = 2
}
/** 登录类型 */
export enum LOGIN_TYPE {
    /** 密码登录 -客户端 &供应链 */
    Account = 1,
    /** 验证码登录 -客户端 &供应链 */
    Captcha = 2,
    /** 重置密码 -供应链*/
    ResetPassword = 3,
    /** 验证身份 -供应链 */
    VerifyIdentity = 4,
    /** 注册账号-客户端 */
    RegisterAccount = 5,
    /** 忘记密码-客户端 */
    ForgetPassword = 6
}
export interface ApiError {
    response?: {
        data?: {
            code?: string;
            message?: string;
        };
        status?: number;
    };
    message?: string;
}
// 类型守卫函数
export const isApiError = (error: unknown): error is ApiError => {
    return typeof error === "object" && error !== null && "response" in error;
};
